<div class="threedot-wrapper">
    @if (expanded) {
    <div (clickOutside)="closeDwellingDropDown()"></div>
    }
    <div class="threedot-icon" (click)="toggleExpanded()"></div>
    <div class="threedot-menu" [class.expanded]="expanded">

        @if(dwelling() || newDwellingProject()) {
        <div class="list-item first" (click)="navigateToNewDwellingOverview()">
            Gå til prosjektoversikt
        </div>

        @if (this.dwelling()?.projectStageEstateTypeId) {
        <div class="list-item" (click)="exportToExcel()">
            Eksporter enhetsliste til Excel
        </div>
        }

        <div class="divider"></div>
        }

        @if(mapLatLon() != null && !mapMode()) {
        <div class="list-item" (click)="navigateToMapDwelling()">
            Vis i evKart
        </div>
        }

        @if(municipalityMapUrl() != null) {
        <div class="list-item" (click)="goToMunicipalityMap()">
            Se i kommunekart
            <span class="external-link"></span>
        </div>
        }

        @if (prospects().length || priceList().length || publications().length) {
        <div class="divider"></div>

        @for (doc of prospects(); track $index) {
        <div class="list-item" (click)="openDocument(doc)">
            Se prospekt
            <span class="external-link"></span>
        </div>
        }

        @for (doc of priceList(); track $index) {
        <div class="list-item" (click)="openDocument(doc)">
            Se prislisten
            <span class="external-link"></span>
        </div>
        }

        @for (pub of publications(); track $index) {
        <div class="list-item" [title]="pub.publicationUrl" (click)="openPublication(pub.publicationUrl)">
            Se {{ pub.groupText }}
            <span class="external-link"></span>
        </div>
        }
        }
    </div>
</div>